import { PromoCodesForm } from 'components/promoCodes/PromoCodesForm/PromoCodesForm'
import { useParams } from 'react-router-dom'

export const PromoCodesCreate: React.FC = () => {
  const { sellerId } = useParams<{ sellerId?: string }>()
  return <PromoCodesForm mode='create' sellerId={sellerId} />
}
